import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { SupplierViewModal } from '../components/procurement/SupplierViewModal';
import { mockPRs } from '../data/mockData';
import { XIcon, EyeIcon } from 'lucide-react';
const mockEOISuppliers = [{
  id: '1',
  supplierId: 'SUP-001',
  supplierName: 'TechCorp Solutions',
  submissionDate: '2023-10-15',
  status: 'Approved',
  documents: ['company_profile.pdf', 'financial_statement.pdf']
}, {
  id: '2',
  supplierId: 'SUP-002',
  supplierName: 'Global Logistics Inc',
  submissionDate: '2023-10-16',
  status: 'Pending',
  documents: ['eoi_submission.pdf']
}];
export function EOIList() {
  const navigate = useNavigate();
  const [isBidderModalOpen, setIsBidderModalOpen] = useState(false);
  const [selectedPRForBidders, setSelectedPRForBidders] = useState<any>(null);
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
  // Filter for approved PRs that use Open Tender
  const data = mockPRs.filter(pr => pr.status === 'Approved' && pr.procurementMethod === 'Open Tender');
  const handleOpenBidders = (pr: any) => {
    setSelectedPRForBidders(pr);
    setIsBidderModalOpen(true);
  };
  const handleViewSupplier = (supplier: any) => {
    setSelectedSupplier(supplier);
    setIsSupplierModalOpen(true);
  };
  const supplierColumns: Column<any>[] = [{
    key: 'supplierName',
    label: 'Supplier Name'
  }, {
    key: 'submissionDate',
    label: 'Submission Date'
  }, {
    key: 'status',
    label: 'Status',
    render: item => <StatusBadge status={item.status} data-id="element-756" />
  }];
  const columns: Column<any>[] = [{
    key: 'prNo',
    label: 'PR No',
    render: pr => <span className="font-medium text-indigo-600" data-id="element-757">{pr.prNo}</span>
  }, {
    key: 'originator',
    label: 'Originator'
  }, {
    key: 'requisitionFor',
    label: 'Requisition For'
  }, {
    key: 'procurementMethod',
    label: 'Method'
  }, {
    key: 'total',
    label: 'Total Amount',
    render: pr => `$${pr.total.toLocaleString()}`
  }, {
    key: 'status',
    label: 'PR Status',
    render: pr => <StatusBadge status={pr.status} data-id="element-758" />
  }, {
    key: 'eoiStatus',
    label: 'EOI Status',
    render: () => <StatusBadge status="Draft" data-id="element-759" />
  }, {
    key: 'actions',
    label: 'Action',
    render: pr => <div className="flex items-center justify-end space-x-3" data-id="element-760">
          <button onClick={() => handleOpenBidders(pr)} className="text-amber-600 hover:text-amber-900 font-medium text-sm" data-id="element-761">
            Bidder
          </button>
          <button onClick={() => navigate(`/eoi/${pr.id}`)} className="text-indigo-600 hover:text-indigo-900 font-medium text-sm" data-id="element-762">
            Process EOI
          </button>
        </div>
  }];
  return <div className="space-y-6 h-full flex flex-col pb-8" data-id="element-763">
      <div className="flex items-center justify-between" data-id="element-764">
        <div data-id="element-765">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-766">
            Expression of Interest (EOI)
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-767">
            Process EOI for approved Open Tender purchase requisitions.
          </p>
        </div>
      </div>

      <div className="flex-1 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-768">
        <div className="flex-1 p-0" data-id="element-769">
          <DataTable columns={columns} data={data} keyExtractor={item => item.id} searchPlaceholder="Search PRs..." data-id="element-770" />
        </div>
      </div>

      {/* Bidders Modal — Supplier Submissions */}
      {isBidderModalOpen && selectedPRForBidders && <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-771">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0" data-id="element-772">
            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={() => setIsBidderModalOpen(false)} data-id="element-773"></div>

            <div className="relative inline-block w-full max-w-4xl px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:p-6" data-id="element-774">
              <div className="absolute top-0 right-0 pt-4 pr-4" data-id="element-775">
                <button type="button" className="text-gray-400 bg-white rounded-md hover:text-gray-500" onClick={() => setIsBidderModalOpen(false)} data-id="element-776">
                  <XIcon className="w-6 h-6" data-id="element-777" />
                </button>
              </div>

              <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-778">
                Supplier Submissions
              </h3>

              <DataTable columns={supplierColumns} data={mockEOISuppliers} keyExtractor={item => item.id} searchPlaceholder="Search..." actions={item => <button onClick={() => handleViewSupplier(item)} className="inline-flex items-center text-indigo-600 hover:text-indigo-900 font-medium text-sm" data-id="element-780">
                    <EyeIcon className="h-4 w-4 mr-1" data-id="element-781" />
                    View
                  </button>} data-id="element-779" />
            </div>
          </div>
        </div>}

      {/* Supplier Detail Modal */}
      <SupplierViewModal isOpen={isSupplierModalOpen} onClose={() => setIsSupplierModalOpen(false)} supplier={selectedSupplier} type="EOI" data-id="element-782" />
    </div>;
}